import gpio from "gpio";

const INA219_ADDRESS = 0x40;

 const INA219_REG_CONFIG                       = 0x00;
    /*---------------------------------------------------------------------*/

/**************************************************************************/
/*! 
    @brief  reset bit
*/
/**************************************************************************/
    const INA219_CONFIG_RESET                    = 0x8000;  // Reset Bit

/**************************************************************************/
/*! 
    @brief  mask for bus voltage range
*/
/**************************************************************************/
    const INA219_CONFIG_BVOLTAGERANGE_MASK       = 0x2000;  // Bus Voltage Range Mask

/**************************************************************************/
/*! 
    @brief  bus voltage range values
*/
/**************************************************************************/
const    INA219_CONFIG_BVOLTAGERANGE_16V        = 0x0000;  // 0-16V Range
const    INA219_CONFIG_BVOLTAGERANGE_32V        = 0x2000;  // 0-32V Range

/**************************************************************************/
/*! 
    @brief  mask for gain bits
*/
/**************************************************************************/
    const INA219_CONFIG_GAIN_MASK                = 0x1800;  // Gain Mask

/**************************************************************************/
/*! 
    @brief  values for gain bits
*/
/**************************************************************************/
const    INA219_CONFIG_GAIN_1_40MV               = 0x0000;  // Gain 1, 40mV Range
const    INA219_CONFIG_GAIN_2_80MV               = 0x0800;  // Gain 2, 80mV Range
const    INA219_CONFIG_GAIN_4_160MV              = 0x1000;  // Gain 4, 160mV Range
const    INA219_CONFIG_GAIN_8_320MV              = 0x1800;  // Gain 8, 320mV Range
    
  /**************************************************************************/
/*! 
    @brief  mask for bus ADC resolution bits
*/
/**************************************************************************/
    const INA219_CONFIG_BADCRES_MASK             = 0x0780;  // Bus ADC Resolution Mask

/**************************************************************************/
/*! 
    @brief  values for bus ADC resolution
*/
/**************************************************************************/
const    INA219_CONFIG_BADCRES_9BIT              = 0x0000;  // 9-bit bus res = 0..511
const    INA219_CONFIG_BADCRES_10BIT             = 0x0080;  // 10-bit bus res = 0..1023
const    INA219_CONFIG_BADCRES_11BIT             = 0x0100;  // 11-bit bus res = 0..2047
const    INA219_CONFIG_BADCRES_12BIT             = 0x0180;  // 12-bit bus res = 0..4097

/**************************************************************************/
/*! 
    @brief  mask for shunt ADC resolution bits
*/
/**************************************************************************/  
    const INA219_CONFIG_SADCRES_MASK             = 0x0078; // Shunt ADC Resolution and Averaging Mask

/**************************************************************************/
/*! 
    @brief  values for shunt ADC resolution
*/
/**************************************************************************/
const    INA219_CONFIG_SADCRES_9BIT_1S_84US      = 0x0000;  // 1 x 9-bit shunt sample
const    INA219_CONFIG_SADCRES_10BIT_1S_148US    = 0x0008;  // 1 x 10-bit shunt sample
const    INA219_CONFIG_SADCRES_11BIT_1S_276US    = 0x0010;  // 1 x 11-bit shunt sample
const    INA219_CONFIG_SADCRES_12BIT_1S_532US    = 0x0018;  // 1 x 12-bit shunt sample
const    INA219_CONFIG_SADCRES_12BIT_2S_1060US   = 0x0048;	 // 2 x 12-bit shunt samples averaged together
const    INA219_CONFIG_SADCRES_12BIT_4S_2130US   = 0x0050;  // 4 x 12-bit shunt samples averaged together
const    INA219_CONFIG_SADCRES_12BIT_8S_4260US   = 0x0058;  // 8 x 12-bit shunt samples averaged together
const    INA219_CONFIG_SADCRES_12BIT_16S_8510US  = 0x0060;  // 16 x 12-bit shunt samples averaged together
const    INA219_CONFIG_SADCRES_12BIT_32S_17MS    = 0x0068;  // 32 x 12-bit shunt samples averaged together
const    INA219_CONFIG_SADCRES_12BIT_64S_34MS    = 0x0070;  // 64 x 12-bit shunt samples averaged together
const    INA219_CONFIG_SADCRES_12BIT_128S_69MS   = 0x0078;  // 128 x 12-bit shunt samples averaged together

/**************************************************************************/
/*! 
    @brief  mask for operating mode bits
*/
/**************************************************************************/
    const INA219_CONFIG_MODE_MASK                = 0x0007;  // Operating Mode Mask

/**************************************************************************/
/*! 
    @brief  values for operating mode
*/
/**************************************************************************/
const    INA219_CONFIG_MODE_POWERDOWN            = 0x0000;
const    INA219_CONFIG_MODE_SVOLT_TRIGGERED      = 0x0001;
const    INA219_CONFIG_MODE_BVOLT_TRIGGERED      = 0x0002;
const    INA219_CONFIG_MODE_SANDBVOLT_TRIGGERED  = 0x0003;
const    INA219_CONFIG_MODE_ADCOFF               = 0x0004;
const    INA219_CONFIG_MODE_SVOLT_CONTINUOUS    = 0x0005;
const    INA219_CONFIG_MODE_BVOLT_CONTINUOUS     = 0x0006;
const    INA219_CONFIG_MODE_SANDBVOLT_CONTINUOUS  = 0x0007;
/*=========================================================================*/

/**************************************************************************/
/*! 
    @brief  shunt voltage register
*/
/**************************************************************************/
    const INA219_REG_SHUNTVOLTAGE                = 0x01;
/*=========================================================================*/

/**************************************************************************/
/*! 
    @brief  bus voltage register
*/
/**************************************************************************/
    const INA219_REG_BUSVOLTAGE                  = 0x02;
/*=========================================================================*/

/**************************************************************************/
/*! 
    @brief  power register
*/
/**************************************************************************/
    const INA219_REG_POWER                       = 0x03;
/*=========================================================================*/

/**************************************************************************/
/*! 
    @brief  current register
*/
/**************************************************************************/
    const INA219_REG_CURRENT                     = 0x04;
/*=========================================================================*/

/**************************************************************************/
/*! 
    @brief  calibration register
*/
/**************************************************************************/
    const INA219_REG_CALIBRATION                 = 0x05;
/*=========================================================================*/

class INA219 {
	constructor(chip_address) {

		this.__ina219_i2caddr = (chip_address === undefined ? INA219_ADDRESS : chip_address);
		this.__ina219_calValue = null;

		// The following multipliers are used to convert raw current and power
		// values to mA and mW, taking into account the current config settings
		this.__ina219_currentDivider_mA = null;
		this.__ina219_powerMultiplier_mW = null;
	}
	__write(reg, value) {
/*
		gpio.i2c[1].writeByte(this.__ina219_i2caddr, reg);
		gpio.i2c[1].writeByte(this.__ina219_i2caddr, ((value >> 8) & 0xFF));
		gpio.i2c[1].writeByte(this.__ina219_i2caddr, (value & 0xFF));
*/
		gpio.i2c[1].writeBlockData( this.__ina219_i2caddr, new Uint8Array([reg, ((value >> 8) & 0xFF), (value & 0xFF)]) );
	}
	__readSync(reg) {
		gpio.i2c[1].writeByte(this.__ina219_i2caddr, reg);

		/* TODO: delay 1ms */

		var value1 = gpio.i2c[1].readByte(this.__ina219_i2caddr);
		var value2 = gpio.i2c[1].readByte(this.__ina219_i2caddr);

		return(parseFloat((value1 << 8) | value2));
	}
	__read(reg) {
		return new Promise(function(resolve, reject) {
			gpio.i2c[1].writeByte(this.__ina219_i2caddr, reg);
			setTimeout(function() {
				var value = new Int8Array( gpio.i2c[1].readBlockData(this.__ina219_i2caddr, 2) );
				//var value1 = gpio.i2c[1].readByte(this.__ina219_i2caddr);
				//var value2 = gpio.i2c[1].readByte(this.__ina219_i2caddr);

				//resolve(parseInt((value1 << 8) | value2));
				resolve(((Math.abs(value[0]) << 8) | Math.abs(value[1])));
			}.bind(this), 1);
		}.bind(this));
	}
	setCalibration_32V_2A() {
		this.__ina219_calValue = 4096;
		this.__ina219_currentDivider_mA = 10;  // Current LSB = 100uA per bit (1000/100 = 10)
		this.__ina219_powerMultiplier_mW = 2;     // Power LSB = 1mW per bit (2/1)

		this.__write(INA219_REG_CALIBRATION, this.__ina219_calValue);

		var config = INA219_CONFIG_BVOLTAGERANGE_32V |
                    INA219_CONFIG_GAIN_8_320MV |
                    INA219_CONFIG_BADCRES_12BIT |
                    INA219_CONFIG_SADCRES_12BIT_1S_532US |
                    INA219_CONFIG_MODE_SANDBVOLT_CONTINUOUS;

		this.__write(INA219_REG_CONFIG, config);
	}
	setCalibration_32V_1A() {
	}
	setCalibration_16V_400mA() {
		this.__ina219_calValue = 8192;
		this.__ina219_currentDivider_mA = 20;  // Current LSB = 50uA per bit (1000/50 = 20)
		this.__ina219_powerMultiplier_mW = 1;     // Power LSB = 1mW per bit

		this.__write(INA219_REG_CALIBRATION, this.__ina219_calValue);

		var config = INA219_CONFIG_BVOLTAGERANGE_16V |
                    INA219_CONFIG_GAIN_1_40MV |
                    INA219_CONFIG_BADCRES_12BIT |
                    INA219_CONFIG_SADCRES_12BIT_1S_532US |
                    INA219_CONFIG_MODE_SANDBVOLT_CONTINUOUS;

		this.__write(INA219_REG_CONFIG, config);
	}
	get busVoltage() {
		var value = this.__readSync(INA219_REG_BUSVOLTAGE);
		return((value >> 3) * 4);
	}
	get shuntVoltage() {
		var value = this.__readSync(INA219_REG_SHUNTVOLTAGE);
		return(value);
	}
	getShuntVoltage() {
		return this.__read(INA219_REG_SHUNTVOLTAGE);
	}
/*
	get current() {
		this.__write(INA219_REG_CALIBRATION, this.__ina219_calValue);
		var value = this.__readSync(INA219_REG_CURRENT);
		return(value);
	}
*/
	getCurrent() {
		return ( new Promise(function(resolve, reject) {
			this.__write(INA219_REG_CALIBRATION, this.__ina219_calValue);
			this.__read(INA219_REG_CURRENT).then(function(result) {
				result /= this.__ina219_currentDivider_mA;
				result /= 1000;
				resolve(result);
			}.bind(this) );
		}.bind(this)) );
	}
	get power() {
	}
}

export default INA219;